import { boot } from 'quasar/wrappers'
import axios from 'axios'
import Notify from 'quasar/src/plugins/Notify.js';
import { isSubscriptionBlocked } from 'src/helpers/subscription'

const nsApi = axios.create({ baseURL: process.env.NS_DOMAIN })
const api = axios.create({ withCredentials: true })

export async function getBaseUrlFromPiva(piva) {
  const { data } = await nsApi.post('/', { piva, app: process.env.URI })
  return data
}

export default boot(async ({ Vue, store, router }) => {
  await store.dispatch('tenant/init')

  api.interceptors.request.use(config => ({
    ...config,
    baseURL: store.getters['tenant/url'],
  }), error => Promise.reject(error))

  // stato del canone: header presenti solo in tolleranza, assenti con stato attivo.
  // Su Network Error axios 0.27 mette l'XHR in error.response (senza headers): lo stato resta invariato
  const readSubscriptionHeaders = ({ headers }) => headers && store.commit('subscription/setStatus', {
    status: headers['x-subscription-status'],
    validUntil: headers['x-subscription-valid-until'],
  })

  api.interceptors.response.use(response => {
    readSubscriptionHeaders(response)
    return response
  }, error => {
    if (isSubscriptionBlocked(error)) {
      store.commit('subscription/setBlocked', {
        message: error.response.data.message,
        hasSession: !['login', 'token'].includes(error.config.url),
      })
      // prima della navigazione iniziale ci pensa la guard in boot/auth
      router.currentRoute.matched.length > 0 && router.currentRoute.path !== '/402' && router.push('/402').catch(() => {})
      return Promise.reject(error)
    }
    error.response && readSubscriptionHeaders(error.response)

    if (error.response) {
      if (![422, 404].includes(error.response.status) && store.state.apis.finish) {
        if (process.env.PROD) {
          Notify.create({
            message: (error.response.data && error.response.data.message) ? 'Attenzione' : 'Operazione non riuscita',
            caption: (error.response.data && error.response.data.message) || 'Abbiamo riscontrato un problema con il server',
            type: 'negative',
          })
        } else {
          Notify.create({
            type: 'negative',
            message: JSON.stringify(error.message),
            caption: error.response.data.message,
            closeBtn: true,
            timeout: 0,
          })
        }
      }
    } else if (error.name !== 'InvalidTenant') Notify.create({ type: 'negative', message: 'Server non raggiungibile' })
    return Promise.reject(error)
  })

  Vue.prototype.$ax = api
})

export { api, nsApi }
